import useFilteredData from 'hooks/useFilteredData';

// Your component code
const SelectData = ({
  data,
  option,
  name
}: {
  data: any | null | undefined;
  option: any[];
  name?: string;
}) => {
  const filteredCategory = useFilteredData({ data, option }); // Pass arguments as an object
  let label = filteredCategory ? (name ? filteredCategory[name] : filteredCategory?.label) : '';
  label = label?.toLocaleString('ko-KR');

  return <>{label}</>;
};

export default SelectData;
